import React from "react";
import Modal from "react-responsive-modal";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./ProductImageCarouselModal.css";
import { getAssetUrl } from "../../../helpers/getAssetUrl";

const responsive = {
	all: {
		breakpoint: { max: 4000, min: 0 },
		items: 1,
	},
};

/**
 * Modal that shows product image(s) in a carousel with product name, price, and Add button.
 * Opened when user clicks the product image in the list.
 */
function ProductImageCarouselModal({
	open,
	onClose,
	item,
	restaurant,
	isItemInCart,
	hasAddons,
	onAdd,
	onOpenCustomize,
	onViewCart,
	forceUpdate,
}) {
	if (!item) return null;

	// Slider: use API item.images when present, else fallback to single item.image
	// Support shapes like:
	// - ["url1", "url2"]
	// - [{ image_path, is_default, sort_order, ... }, ...]
	const rawImages = item.images && Array.isArray(item.images) && item.images.length > 0 ? item.images : [];

	const normalized = rawImages
		.map((entry) => {
			if (typeof entry === "string") {
				return { url: entry, is_default: false, sort_order: 0 };
			}
			if (entry && typeof entry === "object") {
				return {
					url: entry.image_path || entry.path || entry.url || entry.image || entry.src || "",
					is_default: !!entry.is_default,
					sort_order: typeof entry.sort_order === "number" ? entry.sort_order : 0,
				};
			}
			return null;
		})
		.filter((img) => img && img.url);

	const images = normalized.length > 0
		// Default image first, then by sort_order
		? normalized
				.sort((a, b) => {
					if (a.is_default === b.is_default) {
						return a.sort_order - b.sort_order;
					}
					return a.is_default ? -1 : 1;
				})
				.map((img) => img.url)
		: (item.image ? [item.image] : []);

	const handleAdd = () => {
		if (hasAddons) {
			onOpenCustomize(item);
		} else if (isItemInCart && onViewCart) {
			onViewCart();
		} else {
			onAdd(item);
			if (forceUpdate) forceUpdate();
		}
		onClose();
	};

	return (
		<Modal
			open={open}
			onClose={onClose}
			closeIconSize={28}
			styles={{ modal: { borderRadius: 12, padding: 0, maxWidth: 400 } }}
		>
			<div className="product-image-carousel-modal">
				{images.length > 0 && (
					<div className="product-image-carousel-modal__carousel">
						<Carousel
							responsive={responsive}
							swipeable={true}
							draggable={true}
							showDots={images.length > 1}
							arrows={images.length > 1}
							infinite={images.length > 1}
							containerClass="product-image-carousel-modal__carousel-inner"
							itemClass="product-image-carousel-modal__slide"
						>
							{images.map((src, i) => (
								<div key={i} className="product-image-carousel-modal__image-wrap">
									<img
										src={getAssetUrl(src)}
										alt={item.name}
										className="product-image-carousel-modal__image"
									/>
								</div>
							))}
						</Carousel>
					</div>
				)}
				<div className="product-image-carousel-modal__info">
					<h3 className="product-image-carousel-modal__name">{item.name}</h3>
					{(() => {
						const hasAddons = item.addons && Object.keys(item.addons).length > 0;
						const fromPrice = item.lowestPriceAddon && item.lowestPriceAddon.price != null;
						const showFrom = hasAddons && (Number(item.price) === 0 || item.price == null) && fromPrice;
						const value = showFrom ? item.lowestPriceAddon.price : (item.price != null ? item.price : 0);
						const showPrice = (typeof value === "number" && value > 0) || (value !== "" && value != null);
						if (!showPrice) return null;
						const prefix = showFrom ? (localStorage.getItem("fromPriceText") || "From ") : "";
						return (
							<p className="product-image-carousel-modal__price">
								{localStorage.getItem("currencySymbolAlign") === "left" && localStorage.getItem("currencyFormat")}
								{prefix}{value}
								{localStorage.getItem("currencySymbolAlign") === "right" && localStorage.getItem("currencyFormat")}
							</p>
						);
					})()}
					<button
						type="button"
						className="btn btn-lg product-image-carousel-modal__add"
						style={{
							backgroundColor: localStorage.getItem("cartColorBg") || "#60b246",
							color: localStorage.getItem("cartColorText") || "#fff",
						}}
						onClick={handleAdd}
					>
						{hasAddons
							? (localStorage.getItem("customizationBtnText") || "Customize")
							: isItemInCart
								? (localStorage.getItem("viewCartButtonText") || "View Cart")
								: (localStorage.getItem("addButtonText") || "Add")}
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default ProductImageCarouselModal;
